<wiz-vgroup width="100%" height="100%" padding="0px">
  <wiz-hgroup gap="5" height="40px" verticalAlign="center">
    <!-- <wiz-label #kindLbl class="smallTitleLabel" [wizNbLine]="1"></wiz-label> -->
    <wiz-icon #icoSelect [visible]="showSelect && !gatlingMode"
      (click)="askForSelect($event)"
      style="cursor: pointer; font-size: 20px" tooltipPlacement="right"
      [wizTooltip]="'$.freedata.form.choose.$'">icon-edit</wiz-icon>

    <wiz-icon
      (click)="beforeAskForAdd()" [visible]="showAdd && !gatlingMode"
      style="cursor: pointer; font-size: 24px" tooltipPlacement="right" 
      [wizTooltip]="'$.form.new.item.$'">icon-add</wiz-icon>
    
    <wiz-icon
      (click)="askForClone()" [visible]="gatlingMode && !!cloneExist"
      class="basicIcon bigOrange hoversave"  tooltipPlacement="right" 
      [wizTooltip]="'$.form.new.item.$'"><mat-icon>arrow_circle_right-add</mat-icon></wiz-icon>  

    <wiz-icon #icoClone [visible]="showAdd && !!cloneExist && !hasUpdate && !gatlingMode" [wizDisabled]="!mayAdd()"
    (click)="askForClone()"
    style="cursor: pointer; font-size: 24px" tooltipPlacement="right"
    [wizTooltip]="'$.common.clone.$'">duplicate</wiz-icon>
    
    <wiz-spacer width="15px"></wiz-spacer>

    <wiz-icon #icoDelete [visible]="showDelete && mayDelete() && !gatlingMode"
      (click)="askForDelete()" [wizDisabled]="!mayDelete()"
      style="cursor: pointer; font-size: 24px" tooltipPlacement="right"
      [wizTooltip]="'$.form.delete.item.$'">icon-delete</wiz-icon>
      
    <wiz-icon #icoUnselect [visible]="!!clone && showRevert && !gatlingMode"
      (click)="askForUnselect()"
      style="cursor: pointer; font-size: 24px" tooltipPlacement="right"
      [wizTooltip]="'$.common.unselect.$'">icon-cancel</wiz-icon>



    <!-- petits boutons -->
    <wiz-hgroup width="100%" [horizontalAlign]="'end'" [verticalAlign]="'center'" 
      padding="5px" [visible]="!!clone && editMode && specifMode && hasUpdate && !gatlingMode">
      <wiz-icon class="basicIcon bigGreen hoversave" style="cursor: pointer;" [wizTooltip]="'$.common.save.modification.$'" 
        tooltipPlacement="top" 
        (click)="doValid($event)"
        [wizDisabled]="saveDisabled"><mat-icon>check_circle</mat-icon></wiz-icon>
      <wiz-icon class="basicIcon black hoversave" style="cursor: pointer;" [wizTooltip]="'$.common.cancel.modification.$'" 
        tooltipPlacement="top"
        (click)="askForCancel($event)"><mat-icon>cancel</mat-icon></wiz-icon> 
    </wiz-hgroup>   

    
    <wiz-hgroup width="100%" [horizontalAlign]="'end'" [verticalAlign]="'end'"  padding="5px" [visible]="!!clone && editMode && !specifMode">
      <!-- icones pour mode spécif -->
      <wiz-button
        #btnSave
        (wizClick)="doValid($event)"
        [wizDisabled]="saveDisabled"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        (wizClick)="doCancel($event)"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>
  </wiz-hgroup>

  <wiz-vgroup #argsZone [visible]="!!clone" width="100%" height="100%" style="display: flex; flex-wrap: wrap" wizOverflow="auto">
    <freedata-gridster wizDragDrop 
    [model]="model"
    [wizDropEnabled]="true" 
    width="100%" height="100%" 
    [freedataValue]="clone"
    [restrictSet]="restrictSet"
    [hiddenGroups]="hiddenGroups"
    [widgets]="widgetItems"></freedata-gridster>
  </wiz-vgroup>
</wiz-vgroup>
